const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23.39 10.53 13.46.6a2.07 2.07 0 0 0-2.92 0L.61 10.54a2.06 2.06 0 0 0 0 2.92l9.93 9.92A2 2 0 0 0 12 24a2.07 2.07 0 0 0 1.47-.61l9.92-9.92a2.08 2.08 0 0 0 0-2.94ZM11 6.42a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0Zm1.05 11.51a1.54 1.54 0 0 1-1.52-1.47A1.47 1.47 0 0 1 12 14.93a1.53 1.53 0 0 1 1.5 1.47 1.48 1.48 0 0 1-1.45 1.53Z" fill="currentColor"></path></svg>';
export {
  a as default
};
